import { makeDocumentMockData } from '../../modules/documentMockDataFactory'
import type { IContractDocument } from '~/types/document/models'

export const {
  getDocumentListData: getContractDocumentListData,
  getDocumentDataById: getContractDocumentDataById,
  getDocumentListDataByParentId: getContractDocumentListDataByContractId,
} = makeDocumentMockData<IContractDocument>({
  entityName: 'contract',
  storageKeyPrefix: 'contract',
})
